import { render, staticRenderFns } from "./TeacherTimeTable.vue?vue&type=template&id=81d05dfe&scoped=true"
import script from "./TeacherTimeTable.vue?vue&type=script&lang=js"
export * from "./TeacherTimeTable.vue?vue&type=script&lang=js"
import style0 from "./TeacherTimeTable.vue?vue&type=style&index=0&id=81d05dfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d05dfe",
  null
  
)

export default component.exports